var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__wrap"},[_c('p',[_vm._v("\n      403\n    ")]),_c('span',[_vm._v("\n             "+_vm._s(_vm.$t('notPermission'))+"\n          ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }